import { Button, Chip, Icon, Input, Modal } from "@plum-xoxo/admin-dsm";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import React from "react";
import "./components/modal.scss";
import styled from "styled-components";

const DividerDiv = styled.div`
  border: 0.5px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
  margin-bottom: 20px;
`;

const CustomChipBackground = styled(Chip).attrs()`
  background-color: ${(props) => props.theme.palette.primary.c00};
`;

const StyledModal = styled(Modal).attrs()`
  width: 476px;
`;
class EditBtnTextModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      btnText: "",
      showErr: false,
    };
  }

  componentDidMount() {
    const { buttonText = "Redeem now" } = this.props;
    this.setState({ btnText: buttonText });
  }

  handleSubmitClick = () => {
    const { btnText } = this.state;
    if (!btnText.length) {
      this.setState({ showErr: true });
    } else {
      this.setState({ showErr: false });
      this.props.updateBtnText(btnText);
    }
  };

  handleInput = (input) => {
    if (input.length <= 40) {
      this.setState({ btnText: input });
    }
  };

  handleChipClick = (event, label) => {
    this.handleInput(label);
  };

  render() {
    const { toggleModal } = this.props;
    const { btnText, showErr } = this.state;
    return (
      <StyledModal
        isOpen={true}
        size="md"
        onClose={() => {
          toggleModal();
        }}
      >
        <Typography
          component="div"
          className="d-flex justify-content-between align-items-center"
        >
          <Typography.H2>Edit Button Text</Typography.H2>
          <Icon
            iconName="Close"
            onClick={() => {
              toggleModal();
            }}
            size="m"
          />
        </Typography>
        <Typography className="mb-20" color="dark" shade="c200">
          The button text will be the same for all recipients receiving the
          reward.
        </Typography>
        <div>
          {btnText.toLowerCase() === "redeem now" ? (
            <CustomChipBackground
              color="base"
              className="mr-20 mb-20"
              label="Redeem Now"
              customTag={
                <Icon color="blue" shade="c200" iconName="Right" size={"16"} />
              }
            />
          ) : (
            <Chip
              color="base"
              className="mr-20 mb-20"
              label="Redeem Now"
              onClick={this.handleChipClick}
            />
          )}
          {btnText.toLowerCase() === "claim now" ? (
            <CustomChipBackground
              color="base"
              className="mr-20 mb-20"
              label="Claim Now"
              customTag={
                <Icon color="blue" shade="c200" iconName="Right" size={"16"} />
              }
            />
          ) : (
            <Chip
              color="base"
              className="mr-20 mb-20"
              label="Claim Now"
              onClick={this.handleChipClick}
            />
          )}
          {btnText.toLowerCase() === "collect reward" ? (
            <CustomChipBackground
              color="base"
              className="mr-20 mb-20"
              label="Collect Reward"
              customTag={
                <Icon color="blue" shade="c200" iconName="Right" size={"16"} />
              }
            />
          ) : (
            <Chip
              color="base"
              className="mr-20 mb-20"
              label="Collect Reward"
              onClick={this.handleChipClick}
            />
          )}
        </div>
        <DividerDiv />
        <div>
          <Typography.LabelText color="dark" shade="c300" className="mb-4">
            Or Enter your own
          </Typography.LabelText>
          <Input
            value={btnText}
            limit={20}
            onChange={(e) => this.handleInput(e.target.value)}
            error={showErr}
            helperText={showErr ? "Button text cannot be left blank." : ""}
          />
        </div>
        <div className="d-flex justify-content-end mt-20">
          <Button
            onClick={() => {
              toggleModal();
            }}
            className="mr-12"
            variant="plain"
          >
            Cancel
          </Button>
          <Button onClick={() => this.handleSubmitClick()}>Save</Button>
        </div>
      </StyledModal>
    );
  }
}

export default EditBtnTextModal;
